<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<app-cigent-header
  smallTitle=""
  largeTitle="{{'DIV_ACC' | translate}}"
  description="{{'INV_DESCRIPTION' | translate}}"
  descriptionMarginRight="215px">
</app-cigent-header>
<div class="main-container" *ngIf="invitationResponse && version && errorFindingInvitation === false; else invitationError">
  <span class="d3e-invitation-loaded"></span>
  <div class="invite-form">
      <div class="container-verification">
        <h2>{{'FREE_ACCOUNT' | translate}}</h2>
        <p>{{'DIV_INSTA' | translate}}</p>
        <p>{{'DIV_INSTA_2' | translate}}</p>
      </div>
      <mat-card appearance="raised" class="password-rules mat-elevation-z1">
        <mat-card-content>
          <p class="password-rules-title">{{tlMustHave1}}</p>
          <ul>
            <li>
              <span *ngIf="!p.password.errors"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="p.password.errors && !(p.password.errors.required || p.password.errors.minByteLength || p.password.errors.maxByteLength)"><span class="mdi mdi-check-bold success"></span></span>
              <span *ngIf="p.password.errors && (p.password.errors.required || p.password.errors.minByteLength || p.password.errors.maxByteLength)"><span class="mdi mdi-check-bold not-validated"></span></span>
              <strong>10</strong>&nbsp;{{tlMustHave2}}&nbsp;<strong>50</strong>&nbsp;{{tlMustHave3}}
            </li>
            <li>
            <span *ngIf="categoriesSatisfied >= 3"><span class="mdi mdi-check-bold success"></span> </span>
            <span *ngIf="categoriesSatisfied < 3"><span class="mdi mdi-check-bold not-validated" alt="checkmark"></span> </span>
              <span>{{tlMustHave4}}</span>
            </li>
              <li>
                <span *ngIf="hasUpperCase"><span class="mdi mdi-check-bold success"></span></span>
                <span *ngIf="!hasUpperCase"><span class="mdi mdi-check-bold not-validated" alt="checkmark"></span></span>
                <strong>{{tlUppercase}}</strong> {{tlLetter}}
              </li>
              <li>
                <span *ngIf="hasLowerCase"><span class="mdi mdi-check-bold success"></span> </span>
                <span *ngIf="!hasLowerCase"><span class="mdi mdi-check-bold not-validated" alt="checkmark"></span> </span>
                <strong>{{tlLowercase}}</strong> {{tlLetter}}
              </li>
              <li>
                <span *ngIf="hasNumber"><span class="mdi mdi-check-bold success"></span> </span>
                <span *ngIf="!hasNumber"><span class="mdi mdi-check-bold not-validated" alt="checkmark"></span> </span>
                <strong>{{tlNumber}}</strong>
              </li>
              <li>
                <span *ngIf="hasUnicode"><span class="mdi mdi-check-bold success"></span> </span>
                <span *ngIf="!hasUnicode"><span class="mdi mdi-check-bold not-validated" alt="checkmark"></span> </span>
                <strong>{{tlUnicode}}</strong>&nbsp;{{tlUnicode2}}
              </li>
              <li>
                <span *ngIf="hasSpecial"><span class="mdi mdi-check-bold success"></span> </span>
                <span *ngIf="!hasSpecial"><span class="mdi mdi-check-bold not-validated" alt="checkmark"></span> </span>
                <strong>{{'SPECIAL' | translate}}</strong>&nbsp;{{'CHARACTER' | translate}}
              </li>
            </ul>
        </mat-card-content>
      </mat-card>

      <form [formGroup]="fg">
        <div>
            <mat-form-field appearance="outline">
              <mat-label>{{'EMAIL' | translate}}</mat-label>
              <input
                aria-disabled="true"
                disabled="true"
                value="{{invitationResponse?.email}}"
                type="text"
                autocomplete="none"
                matInput
              />
            </mat-form-field>
        </div>
        <div class="password-with-icon">
            <mat-form-field appearance="outline">
              <mat-label>{{'DIV_PW' | translate}}</mat-label>
              <input
                [type]="showPass ? 'text': 'password'"
                autocomplete="new-password"
                matInput
                formControlName="password"
                required
              />
              <mat-error id="passError" *ngIf="p.password.errors" class="invalid-feedback">
                <div *ngIf="p.password.errors.required">{{'SUB_P_REQ' | translate}}</div>
                <div *ngIf="showPasswordError('needsMoreCategories')">{{'PW_ERROR_CAT' | translate}}</div>
                <div *ngIf="showPasswordError('hasMinMaxlength')">{{'SUB_P_LEN' | translate}}</div>
                <div *ngIf="p.password.errors.emailOrSimilar">{{'PW_ERROR_SIM_EMAIL' | translate}}</div>
                <div *ngIf="p.password.errors.containsPipeSymbol">{{'PW_ERROR_CONTAINS_PIPE' | translate}}</div>
              </mat-error>
            </mat-form-field>
            <span (click)="showPass = !showPass">
              <span *ngIf="showPass"><span class="mdi mdi-eye show-hide-pass"></span> </span>
              <span *ngIf="!showPass"><span class="mdi mdi-eye-off show-hide-pass"></span> </span>
            </span>
        </div>

        <div>
            <mat-form-field appearance="outline">
              <mat-label>{{'DIV_CONF_PW' | translate}}</mat-label>
              <input
                [type]="showPass ? 'text': 'password'"
                matInput
                formControlName="confirmPassword"
                required
              />
              <mat-error *ngIf="p.confirmPassword.errors" class="invalid-feedback">
                <div *ngIf="p.confirmPassword.errors.required">{{'SUB_CONFIRM_REQ' | translate}}</div>
                <div *ngIf="p.confirmPassword.errors.mustMatch">{{'SUB_PASS_MATCH' | translate}}</div>
              </mat-error>
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{'FIRST' | translate}}</mat-label>
                <input matInput id="firstName" name="firstName" formControlName="firstName" placeholder="{{'FIRST' | translate}}" maxlength="255">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field appearance="outline">
                <mat-label>{{'LAST' | translate}}</mat-label>
                <input matInput id="lastName" name="lastName" formControlName="lastName" placeholder="{{'LAST' | translate}}" maxlength="255">
            </mat-form-field>
        </div>

        <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!fg.valid || disableButton || version == null">{{'SUBMIT' | translate}}</button>

        <span class="terms-of-use">
          {{'DIV_TOUA' | translate}}
          <a href="https://www.cigent.com/terms" target="_blank" rel="noopener noreferrer">{{'DIV_TOUB' | translate}}</a>{{'DIV_TOUC' | translate}}
          <a href="https://www.cigent.com/policies" target="_blank" rel="noopener noreferrer">{{'DIV_TOUD' | translate}}</a>.
        </span>

      </form>
      <p class="required-fields">{{'DIV_REQUIRED' | translate}}</p>
  </div>
</div>

<div class="content-container">
  <h2>{{'DIV_DESC' | translate}}</h2>
  <p class="intro-paragraph">{{'D3E_CAN_DO_CONTENT' | translate}}</p>
</div>

<div class="custom-button-wrapper">
    <a class="custom-button" href="subscriptions/select"> {{'INV_LEARN_MORE' | translate}} </a>
</div>

<div>
  <p>&nbsp;</p>
</div>

<ng-template #invitationError>
  <mat-card appearance="raised" class="card-container mat-elevation-z1 error-content" *ngIf="invitationResponse != null">
    <mat-card-content>
      <h1>{{'DIV_ALREADY_VERIFIED' | translate}}</h1>
      <p>
        {{'DIV_PLEASE' | translate}}<a routerLink="/login">{{'DIV_SIGNIN' | translate}}</a>{{'DIV_CONSOLE' | translate}}
        {{'DIV_DESKTOP' | translate}}
      </p>
    </mat-card-content>
  </mat-card>
</ng-template>
